module.exports = __webpack_public_path__ + "static/media/billsbot-subscription-shopping-cart.a5717cab.svg";